
import '@/common/js/common-plugins';
const date = new Date();
const today = new Date().format('yyyy-MM-dd');
const nextDay = date.getTime() + 3600 * 1000 * 24;
const monthAgo = date.getTime() - 3600 * 1000 * 24 * 30;
const threeAgo = date.getTime() - 3600 * 1000 * 24 * 3;
const twoAgo = date.getTime() - 3600 * 1000 * 24 * 2;
const yearAgo = date.getTime() - 3600 * 1000 * 24 * 365;


export default {
    'dayRange': [today, new Date(nextDay).format('yyyy-MM-dd')],
    'SecondRange': [new Date(twoAgo).format('yyyy-MM-dd'), new Date(nextDay).format('yyyy-MM-dd')],
    'ThreeRange': [new Date(threeAgo).format('yyyy-MM-dd'), new Date(nextDay).format('yyyy-MM-dd')],
    'monthRange': [new Date(monthAgo).format('yyyy-MM-dd'), new Date(nextDay).format('yyyy-MM-dd')],
    'yaarRange': [new Date(yearAgo).format('yyyy-MM-dd'), new Date(nextDay).format('yyyy-MM-dd')],
}



// WEBPACK FOOTER //
// ./src/service/constant/TimeRange.js